import { useEffect } from 'react';

import {
  useAppInsightsContext,
  useTrackEvent
} from '@microsoft/applicationinsights-react-js';
import { FallbackProps } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';

import { Button, Typography } from '@destination/components';

export const GeneralFallback = ({
  error,
  resetErrorBoundary
}: FallbackProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'general' });
  const appInsights = useAppInsightsContext();
  const trackError = useTrackEvent(appInsights, 'GeneralError', error);

  useEffect(() => {
    trackError(error);
  }, [error, trackError]);

  return (
    <div className="w-full text-center">
      <div className="flex h-8">
        <Typography className="mx-auto mt-auto !leading-4" variant="smallTitle">
          {t('application_name')}
        </Typography>
      </div>
      <div className="mb-8 flex justify-center" data-testid="sad-icon">
        {/*<SadIcon />*/}
      </div>
      <div className="flex flex-col justify-center text-center">
        <Typography variant="smallTitle" className="mb-6">
          {t('something_went_wrong.title')}
        </Typography>
        <Typography variant="description">
          {t('something_went_wrong.description')}
        </Typography>
        <div className="tw-mt-6 tw-flex tw-justify-center">
          <Button variant="primary" onClick={resetErrorBoundary}>
            <Typography variant="smallText">
              {t('something_went_wrong.try_again')}
            </Typography>
          </Button>
        </div>
      </div>
    </div>
  );
};
